<template>
  <div class="edit-popup">
    <div class="input-item">
      <div class="label">学生姓名</div>
      <input type="text" v-model="name" placeholder="请输入学生姓名" />
    </div>
    <div class="btn-list">
      <Btn title="取消" type="hollow" width="2.2rem" @click="$emit('close')" />
      <Btn title="确认" width="2.2rem" @click="EditName" />
    </div>
  </div>
</template>

<script>
  import { SetImage } from '@/utils/Image'
  export default {
    data () {
      return {
        name: ''
      }
    },
    props: {
      info: {
        type: Object,
        default: () => ({})
      }
    },
    methods: {
      EditName () {
        if (!this.name) {
          this.$ShowToast('请输入')
          return
        }
        this.$Post('Common.editStudentName', {
          cup_id: this.info.id,
          student_name: this.name
        }).then(res => {
          this.name = ''
          this.$emit('refresh')
          this.$ShowToast(res.msg, { icon: 'success' })
        })
      }
    },
    created () {
      this.name = this.info.student_name
    },
    computed: {
      ...SetImage(['IconRight'])
    }
  }
</script>

<style lang="less" scoped>
  .edit-popup {
    .w(6.43rem);
    .p(.6rem .4rem .55rem);
    box-sizing: border-box;
    .input-item {
      .w();
      display: flex;
      align-items: center;
      .h(1rem);
      position: relative;
      border-bottom: 1px solid #e5e5e5;
      .label {
        .w(1.83rem);
        .fz(.3rem);
        .c(#333);
      }
      input {
        flex: 1;
        .fz(.3rem);
      }
      .right-icon {
        .w(.12rem);
        .h(.2rem);
      }
    }
    .btn-list {
      .p(0 .2rem);
      display: flex;
      justify-content: space-between;
      .mt(.5rem);
    }
  }
</style>
